import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyChoose from './components/WhyChoose';
import Excellence from './components/Excellence';
import MobileGaming from './components/MobileGaming';
import Experience from './components/Experience';
import Genres from './components/Genres';
import Journey from './components/Journey';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-[#05050a]">
      <Header />
      <main>
        <Hero />
        <WhyChoose />
        <Excellence />
        <MobileGaming />
        <Experience />
        <Genres />
        <Journey />
        <FAQ />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
